// FilterContext.tsx
import React, { createContext, useContext } from 'react';
import { useFilters } from '../hooks/useFilters';

const FilterContext = createContext<ReturnType<typeof useFilters> | undefined>(undefined);

export const FilterProvider: React.FC<{
  children: React.ReactNode;
  preFilteredCarlineGroup?: string;
}> = ({ children, preFilteredCarlineGroup }) => {
  const filter = useFilters({ preFilteredCarlineGroup });
  return <FilterContext.Provider value={filter}>{children}</FilterContext.Provider>;
};

export const useFilterContext = () => {
  const ctx = useContext(FilterContext);
  if (!ctx) throw new Error('useFilterContext must be used within a FilterProvider');
  return ctx;
};
